import { SectionWithRichTextProps } from './query';
import Text from '@/components/molecules/Text';

export const SectionWithRichText = (sectionWithRichTextData: SectionWithRichTextProps) => {
	return (
		<Text>
			{sectionWithRichTextData.value}
		</Text>
	);
};

export default SectionWithRichText;
